import { CommonModule } from '@angular/common';
import { Component, inject, Input, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IndexService } from '../../../services';
import { ToastService } from '../../../services/toast-service';
import { HttpErrorResponse } from '@angular/common/http';
import { IndexItem } from '../../../shared/interfaces';

@Component({
    selector: 'app-delete-index-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './delete-index-modal.html'
})
export class DeleteIndexModalComponent {
    activeModal = inject(NgbActiveModal);
    private readonly indexService = inject(IndexService);
    public toastService = inject(ToastService);

    @Input() indexItem!: IndexItem;

    isDeleting = signal(false);

    confirmDelete() {
        if (!this.indexItem) return;

        this.isDeleting.set(true);

        this.indexService.deleteIndex(this.indexItem.name).subscribe({
            next: () => {
                this.isDeleting.set(false);
                this.activeModal.close(true); // Restituisce true per successo
            },
            error: (response: HttpErrorResponse) => {
                console.error('Errore eliminazione:', response);
                this.isDeleting.set(false);
                this.toastService.show(`Errore durante l'eliminazione dell'indice: ${response.error.message}`, 'error');
            }
        });
    }

    dismiss() {
        this.activeModal.dismiss();
    }
}
